import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import {
  LayoutDashboard,
  Users,
  Briefcase,
  ClipboardList,
  PhoneOff,
  AlertTriangle,
  CreditCard,
  Calendar,
  Star,
  Settings,
  ChevronLeft,
  ChevronRight,
  LogOut,
  MessageSquare,
  MapPin,
  BarChart3,
  ShieldCheck,
  ShieldAlert,
  Shield,
  Hammer,
  Building2,
  UserCog,
  Award,
  UserRound,
  DollarSign,
  Wallet,
  Undo2,
  FileWarning,
  Clock,
  Calculator,
  HardHat
} from 'lucide-react';
import logo from '../../assets/dozy-logo.svg';

// `roles` limita quem vê cada entrada. Sem `roles` = visível a todo o staff.
// O supervisor (RBAC da doc) só media disputas e valida qualidade.
const ADMIN = ['admin', 'super_admin'];
const ALL_STAFF = ['admin', 'super_admin', 'supervisor'];
const OPS = ['operations_manager'];

const menuItems = [
  { path: '/admin', label: 'Painel', icon: LayoutDashboard, exact: true, roles: ADMIN },
  { path: '/admin', label: 'Início', icon: LayoutDashboard, exact: true, roles: ['supervisor'] },
  { path: '/admin', label: 'Operações', icon: LayoutDashboard, exact: true, roles: OPS },
  { path: '/admin/pipeline', label: 'Profissionais', icon: Users, roles: OPS },
  { path: '/admin/verifications', label: 'Verificações', icon: ShieldCheck, roles: OPS },
  { path: '/admin/requests', label: 'Pedidos', icon: ClipboardList, roles: OPS },
  { path: '/admin/projects', label: 'Obras', icon: Hammer, roles: OPS },
  { path: '/admin/checklists', label: 'Listas de verificação', icon: ClipboardList, roles: OPS },
  { path: '/admin/sms-falhados', label: 'Avisos por entregar', icon: PhoneOff, roles: OPS },
  { path: '/admin/obras-paradas', label: 'Obras paradas', icon: AlertTriangle, roles: OPS },
  { path: '/admin/devolucoes', label: 'Devoluções', icon: Undo2, roles: OPS },
  { path: '/admin/fiscal-por-apurar', label: 'Fiscal por apurar', icon: FileWarning, roles: OPS },
  { path: '/admin/fases-atraso', label: 'Fases em atraso', icon: Clock, roles: OPS },
  { path: '/admin/businesses', label: 'Empresas', icon: Building2, roles: OPS },
  // A de cima é a empresa que encomenda; esta é a que executa. Duas listas
  // porque são duas decisões diferentes, ainda que a mesma empresa possa
  // aparecer nas duas.
  { path: '/admin/empresas-prestadoras', label: 'Empresas prestadoras', icon: HardHat, roles: OPS },
  { path: '/admin/planos', label: 'Planos', icon: CreditCard, roles: OPS },
  { path: '/admin/zones', label: 'Zonas', icon: MapPin, roles: OPS },
  { path: '/admin/staff', label: 'Colaboradores', icon: Shield, roles: OPS },
  { path: '/admin/account', label: 'A minha conta', icon: UserCog, roles: OPS },
  { path: '/admin/users', label: 'Utilizadores', icon: Users, roles: ADMIN },
  { path: '/admin/clients', label: 'Clientes', icon: UserRound, roles: ADMIN },
  { path: '/admin/workers', label: 'Profissionais', icon: Briefcase, roles: ADMIN },
  { path: '/admin/verifications', label: 'Verificações', icon: ShieldCheck, roles: ALL_STAFF },
  { path: '/admin/portfolio', label: 'Portfólio', icon: Award, roles: ADMIN },
  { path: '/admin/requests', label: 'Pedidos', icon: ClipboardList, roles: ALL_STAFF },
  { path: '/admin/appointments', label: 'Agendamentos', icon: Calendar, roles: ADMIN },
  { path: '/admin/disputes', label: 'Mediações', icon: AlertTriangle, roles: ALL_STAFF },
  { path: '/admin/payments', label: 'Pagamentos', icon: CreditCard, roles: ADMIN },
  { path: '/admin/withdrawals', label: 'Levantamentos', icon: Wallet, roles: ADMIN },
  { path: '/admin/reviews', label: 'Avaliações', icon: Star, roles: ALL_STAFF },
  { path: '/admin/messages', label: 'Mensagens', icon: MessageSquare, roles: ADMIN },
  { path: '/admin/location', label: 'Geolocalização', icon: MapPin, roles: ADMIN },
  { path: '/admin/receitas', label: 'Receitas', icon: DollarSign, roles: ADMIN },
  { path: '/admin/tax-engine', label: 'Motor fiscal', icon: Calculator, roles: ADMIN },
  { path: '/admin/analytics', label: 'Estatísticas', icon: BarChart3, roles: ADMIN },
  { path: '/admin/projects', label: 'Obras', icon: Hammer, roles: ADMIN },
  { path: '/admin/checklists', label: 'Listas de verificação', icon: ClipboardList, roles: ADMIN },
  { path: '/admin/sms-falhados', label: 'Avisos por entregar', icon: PhoneOff, roles: ADMIN },
  { path: '/admin/obras-paradas', label: 'Obras paradas', icon: AlertTriangle, roles: ADMIN },
  { path: '/admin/devolucoes', label: 'Devoluções', icon: Undo2, roles: ADMIN },
  { path: '/admin/fiscal-por-apurar', label: 'Fiscal por apurar', icon: FileWarning, roles: ADMIN },
  { path: '/admin/fases-atraso', label: 'Fases em atraso', icon: Clock, roles: ADMIN },
  { path: '/admin/businesses', label: 'Empresas', icon: Building2, roles: ADMIN },
  { path: '/admin/empresas-prestadoras', label: 'Empresas prestadoras', icon: HardHat, roles: ADMIN },
  { path: '/admin/planos', label: 'Planos', icon: CreditCard, roles: ADMIN },
  { path: '/admin/zones', label: 'Zonas', icon: MapPin, roles: ADMIN },
  { path: '/admin/staff', label: 'Colaboradores', icon: Shield, roles: ADMIN },
  { path: '/admin/integrity', label: 'Integridade', icon: ShieldAlert, roles: ALL_STAFF },
  { path: '/admin/account', label: 'A minha conta', icon: UserCog, roles: ALL_STAFF },
  { path: '/admin/settings', label: 'Configurações', icon: Settings, roles: ['super_admin'] },
];

const ROLE_LABEL = {
  supervisor: 'Painel de Supervisão',
  operations_manager: 'Operações',
  admin: 'Painel de Administração',
  super_admin: 'Painel de Administração',
};

const Sidebar = ({ user, onLogout, notifications = 0 }) => {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();

  const role = user?.role || 'admin';
  const visibleItems = menuItems.filter((item) => !item.roles || item.roles.includes(role));

  return (
    <aside
      className={`admin-sidebar bg-gray-900 border-r border-gray-800 flex flex-col transition-all duration-300 h-screen sticky top-0
        ${collapsed ? 'w-20' : 'w-64'}`}
    >
      {/* Logo */}
      <div className="admin-sidebar-brand p-4 border-b border-gray-800 flex items-center justify-between">
        <div className={`flex items-center gap-3 ${collapsed ? 'justify-center w-full' : ''}`}>
          <img src={logo} alt="Dozy" className="admin-sidebar-logo" />
          {!collapsed && (
            <div>
              <h1 className="text-white font-bold text-lg tracking-tight">Dozy <span className="admin-sidebar-admin">Admin</span></h1>
              <p className="text-gray-500 text-xs">{ROLE_LABEL[role] || 'Painel de Administração'}</p>
            </div>
          )}
        </div>
        <button
          onClick={() => setCollapsed(!collapsed)}
          className="text-gray-500 hover:text-white transition-colors p-1"
        >
          {collapsed ? <ChevronRight className="w-4 h-4" /> : <ChevronLeft className="w-4 h-4" />}
        </button>
      </div>

      {/* Navigation */}
      <nav className="admin-sidebar-nav flex-1 overflow-y-auto py-4 px-2">
        <ul className="space-y-1">
          {visibleItems.map(item => {
            const isActive = item.exact 
              ? location.pathname === item.path
              : location.pathname.startsWith(item.path);

            return (
              <li key={`${item.path}-${item.label}`}>
                <NavLink
                  to={item.path}
                  className={`flex items-center gap-3 px-3 py-2.5 rounded-lg transition-all duration-200 group relative
                    ${isActive
                      ? 'bg-[#2e5bff]/15 text-[#00f1fe] border-l-2 border-[#2e5bff]'
                      : 'text-gray-400 hover:bg-gray-800 hover:text-white'}`}
                >
                  <item.icon className={`w-5 h-5 flex-shrink-0 ${isActive ? 'text-[#00f1fe]' : ''}`} />
                  {!collapsed && <span className="text-sm font-medium">{item.label}</span>}

                  {/* Tooltip para modo colapsado */}
                  {collapsed && (
                    <div className="absolute left-full ml-2 px-2 py-1 bg-gray-800 text-white text-xs rounded 
                                    opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap z-50
                                    border border-gray-700 shadow-xl">
                      {item.label}
                    </div>
                  )}

                  {/* Badge de notificações */}
                  {item.label === 'Mediações' && notifications > 0 && !collapsed && (
                    <span className="ml-auto bg-red-500 text-white text-xs px-1.5 py-0.5 rounded-full">
                      {notifications}
                    </span>
                  )}
                </NavLink>
              </li>
            );
          })}
        </ul>
      </nav>

      {/* User Profile & Logout */}
      <div className="admin-sidebar-user p-4 border-t border-gray-800">
        <div className={`flex items-center gap-3 mb-3 ${collapsed ? 'justify-center' : ''}`}>
          <div className="w-9 h-9 rounded-full bg-gradient-to-br from-purple-400 to-pink-500 flex items-center justify-center text-white font-semibold text-sm">
            {user?.full_name?.charAt(0)?.toUpperCase() || 'A'}
          </div>
          {!collapsed && (
            <div className="flex-1 min-w-0">
              <p className="text-white text-sm font-medium truncate">{user?.full_name || 'Admin'}</p>
              <p className="text-gray-500 text-xs truncate">{user?.email || 'admin@dozy.com'}</p>
            </div>
          )}
        </div>
        <button
          onClick={onLogout}
          className={`flex items-center gap-2 text-red-400 hover:text-red-300 hover:bg-red-500/10 
                      rounded-lg px-3 py-2 transition-colors text-sm w-full
                      ${collapsed ? 'justify-center' : ''}`}
        >
          <LogOut className="w-4 h-4" />
          {!collapsed && <span>Sair</span>}
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
